import React from "react";

import styles from "./MailNonarrival.module.scss";

const MailNonarrival: React.FC = () => {
  return (
    <div className={styles["mail-nonarrival__text"]}>
      メールが届かない場合は「＠esports-select.com」をドメイン指定受信設定して下さい。
      <br />
      Gmailなどの場合は、迷惑メールフォルダやプロモーションフォルダを確認して下さい。
    </div>
  );
};

export default MailNonarrival;
